import { Outlet } from 'react-router';

import { AppHead } from './app-head.ui';

/**
 * T2 `App / Form`(Figma 2142:138). T1 머리 + 본문 폭 `size.container.form` 1000, 좌우 여백 20(box-content — 좁은 화면에서 여백을 남긴다, DD-65).
 * 본문 = 구획 카드(폼 컴포넌트가 가진 카드)를 20 간격으로 쌓고, 맨 아래 가운데 저장 버튼 줄(300×40, 없을 수 있음).
 * 저장 버튼 줄은 폼을 가진 화면이 그린다: `BottomActionBar`(`className="p-0"` — 줄 위 간격은 이 틀의 20).
 */
export function AppFormLayout() {
  return (
    <div data-template="app-form" className="min-h-screen bg-bg-canvas text-fg-default">
      <AppHead />
      <main className="mx-auto box-content flex max-w-(--size-container-form) flex-col gap-5 px-gutter py-8">
        <Outlet />
      </main>
    </div>
  );
}
